export default __webpack_public_path__ + "static/media/textLabLogo-dark.92ac94bd.svg";